import classNames from 'classnames';
import React from 'react';

interface DividerProps {
  className?: string;
  customColor?: string;
}

const Divider: React.FC<DividerProps> = ({ className, customColor }) => {
  return (
    <hr
      style={{ height: '1px' }}
      className={classNames('border-t-1 !border-x-0 !border-b-0', customColor || 'border-subtle', className)}
    />
  );
};

export default Divider;
